@import 'close';

.alert {
	margin-bottom: 0;
	border-radius: 0;
	padding: $spacer 0;
	position: relative;
	@include text-size(14);
	@include line-height(20);
	
	.container, .container-fluid {
		display: flex;
		align-items: center;		
	}
	p:last-of-type { padding: 0; }
	&-dismissible {

		.container, .container-fluid {
			position: relative;			
		}

		.btn-close {
			padding: 4px 0;
			top: calc((-1 * #{$spacer}) + #{$gutter-sm});
		}
	}
	
	.btn-close {
		position: absolute;
		top: 5px;
		right: 15px;
		background-size: 13px 13px;
		background: none;
		opacity: 1;
		
		svg {
			@include svg-format(11px, 17px, #000);
		}

		&:hover, &:focus {
			svg { fill: $link-color-primary; }
		}
	}

	&.has-icon {
		
		> .container, .container-fluid {
	
			kdx-arrow-link{
				margin: 0 30px;
			}
		}

		.alert-icon {
			position: relative;
			left: 0;
			margin-right: 16px;
			width: 30px;
			height: 30px;

			svg {
				@include svg-format(30px, 30px, $primary);
			}
			img {
				width: 100%;
				height: 100%;
				max-width: 30px;
				max-height: 30px;
				min-width: 20px;				
			}
		}		
	}
	.cookie-links {
		margin-left: 16px;
		
		.btn { 
			white-space: nowrap;
			display: flex;
			align-items: center;
			
			svg {
				margin-right: 5px;
				@include svg-format(14px, 14px, currentColor);
			}
		}
	}
	&-general {
		background: $alert-primary-color;

		a:not(.btn) {
			color: $alert-primary-link-color;

			&:hover, &:focus { color: $alert-primary-link-color-hover; }
		}		
		&.has-icon .alert-icon {

			svg { fill: $alert-primary-icon; }
			img { filter: $alert-primary-icon-filter; }
		}
	}
	&-urgent {
		background: $alert-secondary-color;	

		a:not(.btn) {
			color: $alert-secondary-link-color;

			&:hover, &:focus { color: $alert-secondary-link-color-hover; }
		}			
		&.has-icon .alert-icon {

			svg { fill: $alert-secondary-icon; }
			img { filter: $alert-secondary-icon-filter; }
		}
	}

	// Client Scope		
	@include media-breakpoint-down(md) {
		&-dismissible {
			.btn-close {
				padding: 0;
				top: calc((-1 * #{$spacer}) + #{$gutter-def});
				right: 35px;
				background-size: 13px 13px;
			}
		}
		&.has-icon {
			.alert-icon img { width: 30px; }
		}
		&.kdx-alert {
			[class^="arrow-link"]:last-child,
			[class^="arrow-link"] {
				margin: $gutter-sm 0 0;
			}

			&.has-icon {
				> .container {
					padding: 0 35px 16px;
				}

				.alert-icon {
					margin: $gutter-sm auto;
					position: relative;
					left: 0;
					height: 45px;
					width: 45px;
				}
			}

			> .container, > .container-fluid {
				display: flex;
				flex-direction: column;
				padding: 0 35px 16px;
			}
		}
	}
}